// IIFE - Immediately Invoked Function Expression
(function($, window, document) {

    // The $ is now locally scoped 

    // Listen for the jQuery ready event on the document
    $(function() {

        // The DOM is ready!

    });

    /*AOS.init();*/

    gsap.registerPlugin(ScrollTrigger);

    const counter = document.querySelectorAll('.count');
    if (counter) {
      counter.forEach(el => {
        const end = parseFloat(el.dataset.end) || 0;
        const proxy = { val: 0 };

        gsap.to(proxy, {
          val: end,
          duration: 2,
          ease: "power2.out",
          onUpdate: () => {
            el.textContent = Math.round(proxy.val).toLocaleString('pt-BR');
          },
          scrollTrigger: {
            trigger: el,
            start: "top 90%",   // quando o elemento chegar a 80% da viewport
            /*toggleActions: "play none none none", */
            toggleActions: "play none none reverse",
            //once: true          // roda só uma vez
          }
        });
      });     
    }


    const typingEl = document.querySelectorAll(".-typing");
    if (typingEl.length > 0) {
      gsap.utils.toArray(".-typing").forEach((text) => {
        //let text = document.querySelector(".-typing");
        let content = text.textContent;
        text.textContent = ""; // clear first
        gsap.to(text, {
          duration: 2.5,
          text: content,  // Requires TextPlugin
          ease: "none"
        });
      });
    }
    // Fade-in sections on scroll
    gsap.utils.toArray(".-fade-in").forEach((secfade) => {
      gsap.from(secfade, {
        opacity: 0,
        y: 100,
        duration: 1,
        ease: "power2.out",
        scrollTrigger: {
          trigger: secfade,
          start: "top 80%",
          toggleActions: "play none none reverse"
        }
      });
    });

    gsap.utils.toArray(".-animate-in").forEach((sec) => {
      /*gsap.to(sec, {
        opacity: 1,
        y: 0,
        duration: 0.5,
        ease: "none",
        //ease: "power2.out",
        scrollTrigger: {
          trigger: sec,
          start: "top 80%",
          toggleActions: "play none none reverse"
        }
      });*/
      gsap.from(sec, {
        opacity: 0,
        y: 100,
        duration: 1,
        ease: "power2.out",
        scrollTrigger: {
          trigger: sec,
          start: "top 80%",
          toggleActions: "play none none "
        }
      });
    });


    /*read more*/
    var readMoreTrigger = document.getElementsByClassName("-rm-trigger");
    
    var toggleMoreContent = function() {
        var excerpt = this.parentNode.getElementsByClassName('-rm-excerpt')[0];
        var moreText = this.parentNode.getElementsByClassName('-rm-more')[0];

        if (excerpt.style.display === "none") {
          excerpt.style.display = "block";
          moreText.style.display = "none";
          this.innerHTML = "Ver mais";
        } else {
          excerpt.style.display = "none";
          moreText.style.display = "block";
          this.innerHTML = "Ver menos";
        }
    };

    for (var i = 0; i < readMoreTrigger.length; i++) {
        readMoreTrigger[i].addEventListener('click', toggleMoreContent, false);
    }     
    
    //Menu trigger
    var menuTrigger = document.getElementsByClassName("menu-trigger-btn"),
        menu = document.getElementById("main-nav");
    
    var toggleMenu = function() {
    	   //console.log('main nav offcanvas called')
        //menu.classList.toggle("offcanvas-nav-active");
        document.body.classList.toggle("menu-active");
    };

    for (var i = 0; i < menuTrigger.length; i++) {
        menuTrigger[i].addEventListener('click', toggleMenu, false);
    }

    //Search trigger
    var searchTrigger = document.getElementsByClassName("search-trigger-btn");
    
    var toggleSearch = function() {
         //console.log('main nav offcanvas called')
        //menu.classList.toggle("offcanvas-nav-active");
        document.body.classList.toggle("search-active");
    };

    for (var i = 0; i < searchTrigger.length; i++) {
        searchTrigger[i].addEventListener('click', toggleSearch, false);
    }

    //modal trigger
    var modalTrigger = document.getElementsByClassName("modal-trigger-btn");
    
    var toggleModal = function() {
        event.preventDefault();
        const modal = this.dataset.modal;
        if (modal) {
          document.getElementById(modal).classList.add('-modal-active');
        }
         //console.log('main nav offcanvas called')
        //menu.classList.toggle("offcanvas-nav-active");
        document.body.classList.toggle("modal-active");
    };

    for (var i = 0; i < modalTrigger.length; i++) {
        modalTrigger[i].addEventListener('click', toggleModal, false);
    }

    //modal close
    var modalClose = document.getElementsByClassName("modal-close-btn");
    
    var closeModal = function() {
        event.preventDefault();
        const modals = document.querySelectorAll('.-modal');
        modals.forEach(element => {
          element.classList.remove('-modal-active');
        });
        const formModals = document.querySelectorAll('.-modal-form');
        formModals.forEach(element => {
          element.classList.remove('-active');
        });
        document.body.classList.remove("modal-active");
    };

    for (var i = 0; i < modalClose.length; i++) {
        modalClose[i].addEventListener('click', closeModal, false);
    }     
    
    

    function redirect(goto){
        /*var conf = confirm("Are you sure you want to go elswhere?");
        if (conf && goto != '') {
            window.location = goto;
        }*/
        window.location = goto;
    }
   
    /*Anchor scroll*/
    const anchors = document.querySelectorAll(".scroll-anchor");
     
    for (const anchor of anchors) {
      anchor.addEventListener("click", clickHandler);
    }
     
    function clickHandler(e) {
      e.preventDefault();
      const header = document.querySelector("header").offsetHeight;
      const href = this.getAttribute("href"); 
      const offsetTop = document.querySelector(href).offsetTop;
     
      scroll({
        top: offsetTop-header,
        /*top: offsetTop,*/
        behavior: "smooth"
      });
    }

    /*Anchor scroll nav*/
    const anchorsNav = document.querySelectorAll(".scroller > a");
     
    for (const anchorNav of anchorsNav) {
      anchorNav.addEventListener("click", clickHandlerNav);
    }
     
    function clickHandlerNav(e) {
      e.preventDefault();
      let header = document.querySelector("header").offsetHeight;
      let href = this.getAttribute("href"); 
      let split = href.split('#');
      let anchor = '#'+split[1];
      let offsetTop = document.querySelector(anchor).offsetTop;
      if (document.querySelector("header").classList.contains('-sticky')) {
        
      }else{
        header = header-20;
      }
      
      document.body.classList.remove("menu-active");
      
     
      scroll({
        top: offsetTop-header,
        /*top: offsetTop,*/
        behavior: "smooth"
      });
    } 

    /*nav tabs*/
    $('.nav-tab-btn').click(function(){
        event.preventDefault();
        var tabTarget = $(this).data('tab');
        /*console.log(tabTarget);*/
        $(this).closest('.tabs-wrap').find('.tabs-content').removeClass('-visible');
        $(this).closest('.tabs-wrap').find('.tabs-content#'+tabTarget).addClass('-visible');
        $(this).closest('.tabs-wrap').find('.nav-tab-btn').removeClass('active');
        $(this).addClass('active');
    });     


    /*Accordion*/
    $('[data-accordion]').click(function(e) {
        e.preventDefault();
        var parent = $(this).closest('.-accordion');
        /*var elParent = $(this).closest('.-accordion-item');*/

        //parent.find('.-accordion-item').removeClass('-active');

        if ( $(this).closest('.-accordion-item').hasClass('-active') ) {
            if (parent) {
              parent.find('.-accordion-item').removeClass('-active');
            }
            $(this).closest('.-accordion-item').removeClass('-active');
        }else{
            if (parent) {
              parent.find('.-accordion-item').removeClass('-active');
            }
            $(this).closest('.-accordion-item').addClass('-active');
        }
        
    });         
      

    /*Dropdown mobile*/
    $('.dropdown-toggle-hover').click(function(){
      
      if ($(window).width() < 1025) {
        event.preventDefault();
        var ddl = $(this).closest('.dropdown');
        ddl.toggleClass('open');
      }else{
        return;
      }
    });

    /*quick search and toggle filter*/
    const searchInput = document.getElementById('quick-search');
    const filterContainer = document.getElementById('filters-container');
    const groups = document.querySelectorAll('.qs-search-group');
    const notFoundDiv = document.getElementById('qs-not-found');
    const clearSearchBtn = document.getElementById('clear-qs-btn');
    const filterButtons = document.querySelectorAll('.filter-btn');

    function performSearch() {
        const filter = searchInput.value.toLowerCase();
        let totalVisibleItems = 0;

        // 1. If searching, hide the category filter buttons
        if (filter.length > 0) {
            filterContainer.style.display = 'none';
        } else {
            filterContainer.style.display = 'flex'; // Or 'block' depending on CSS
            // Reset to "Show All" state visually when search is cleared
            resetCategories(); 
        }

        groups.forEach(group => {
            const items = group.querySelectorAll('li');
            let hasVisibleItems = false;

            items.forEach(item => {
                const text = item.textContent || item.innerText;
                if (text.toLowerCase().indexOf(filter) > -1) {
                    item.style.display = ""; 
                    hasVisibleItems = true;
                    totalVisibleItems++;
                } else {
                    item.style.display = "none";
                }
            });

            // Show/Hide category section based on matches
            group.style.display = hasVisibleItems ? "" : "none";
        });

        // 2. Show/Hide "Not Found" message
        if (totalVisibleItems === 0 && filter.length > 0) {
            notFoundDiv.style.display = "block";
        } else {
            notFoundDiv.style.display = "none";
        }
    }

    function resetCategories() {
        groups.forEach(group => {
            group.style.display = "";
            group.querySelectorAll('li').forEach(li => li.style.display = "");
        });
        // Reset buttons to "All"
        filterButtons.forEach(btn => btn.classList.remove('active'));
        document.querySelector('.btn-all').classList.add('active');
    }
    if (searchInput) {
      // Event: Typing in search
      searchInput.addEventListener('keyup', performSearch);
    }
    if (clearSearchBtn) {
      // Event: Clear Search Button
      clearSearchBtn.addEventListener('click', function() {
          searchInput.value = '';
          performSearch();
          searchInput.focus();
      });
    }

    if (filterButtons) {
    filterButtons.forEach(button => {
        button.addEventListener('click', function(e) {
            e.preventDefault();
            const targetFilter = this.getAttribute('data-filter');
            
            filterButtons.forEach(btn => btn.classList.remove('active'));
            this.classList.add('active');

            groups.forEach(group => {
                const groupCategory = group.getAttribute('data-category');
                group.style.display = (targetFilter === 'all' || targetFilter === groupCategory) ? "" : "none";
                // Ensure items inside are visible
                group.querySelectorAll('li').forEach(li => li.style.display = "");
            });
        });
    });
    }
    /*Sticky observer*/
    /*document.addEventListener('DOMContentLoaded', function() {
        const header = document.querySelector('.sticky-observer');
        const sentinel = document.querySelector('#sticky-sentinel');

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (!entry.isIntersecting) {
                    header.classList.add('is-sticky');
                } else {
                    header.classList.remove('is-sticky');
                }
            });
        }, {
            threshold: [0]
        });

        observer.observe(sentinel);
    });    */

    /*Tiny slider services*/
    const tnsSliderHighlight = document.querySelectorAll('.-hs-tns');
    var highlightSlideDuration = 5000;
    tnsSliderHighlight.forEach(sliderHighlight => {
        const tnsSliderHighlight = tns({
            
            /*rewind: true,*/
            container: sliderHighlight,
            mode: 'gallery',
            items: 1,
            slideBy: 'page',
            autoplay: true,
            autoplayTimeout: highlightSlideDuration,
            speed: 5000,
            nav: true,
            controls: false,
            autoplayButtonOutput: false,
            autoplayHoverPause: true,
            animateIn: 'fadeInChild',
            animateOut: 'fadeOutChild',
            loop: true,
            /*gutter: 0,
            mouseDrag: true,
            controlsPosition: "bottom",*/
            navPosition: "bottom",
            
            onInit: function(info) {
                var dotsWrappers = document.querySelectorAll('.custom-dots-proxy');
                var totalSlides = info.slideCount;

                dotsWrappers.forEach(function(wrapper) {
                    for (var i = 0; i < totalSlides; i++) {
                        var dot = document.createElement('button');
                        dot.classList.add('proxy-dot');
                        dot.setAttribute('data-index', i);
                        
                        dot.addEventListener('click', function() {
                            tnsSliderHighlight.goTo(this.getAttribute('data-index'));
                        });
                        
                        wrapper.appendChild(dot);
                    }
                });

                //triggerAnimations(info);
                resetProgressBar(info);
                updateNavClasses(info)
                /*updateSliderExtras(info);*/
                /*applyEvenOdd(info);*/
            }
        });
        tnsSliderHighlight.events.on('indexChanged', function(info) {
            //triggerAnimations(info);
            resetProgressBar(info);
            updateNavClasses(info);
        });
        function resetProgressBar(info) {
            var progressBar = document.querySelector('.progress-fill');
            var progressContainer = document.querySelector('.slider-progress-bar');
            if (!progressBar || !progressContainer) return;

            //var info = tnsSliderHighlight.getInfo();
            var activeSlide = info.slideItems[info.index];
            var colorTheme = activeSlide.getAttribute('data-theme') || 'default';

            progressBar.classList.remove('is-animating');
            progressContainer.className = '-hg-progress-bar slider-progress-bar ' + colorTheme;
            progressBar.style.animationPlayState = 'running'; // Reset to running
            
            void progressBar.offsetWidth; 
            progressBar.classList.add('is-animating');
        }

        function updateNavClasses(info) {
            var navContainer = info.navContainer; 
            if (!navContainer) return;
            var activeSlide = info.slideItems[info.index];
            
            var theme = activeSlide.getAttribute('data-theme') || 'default';

            navContainer.className = 'tns-nav ' + theme;

            var navDots = info.navItems;
            for (var i = 0; i < navDots.length; i++) {
                navDots[i].classList.remove('-even', '-odd');
                ((i + 1) % 2 === 0) ? navDots[i].classList.add('-even') : navDots[i].classList.add('-odd');
            }

            /*custom dots*/
            // 1. Get the real index (1-based)
            var currentIndex = info.displayIndex; 

            // 2. Find ALL custom dot wrappers (since they are inside every slide)
            var allProxyWrappers = document.querySelectorAll('.custom-dots-proxy');

            allProxyWrappers.forEach(function(wrapper) {
                // Find all buttons inside THIS specific wrapper
                var dots = wrapper.querySelectorAll('.proxy-dot');
                
                dots.forEach(function(dot, index) {
                    // Check if the dot's index matches the current slide
                    // (index is 0-based, currentIndex is 1-based)
                    if ((index + 1) === currentIndex) {
                        dot.classList.add('is-active');
                        
                        // Add your Even/Odd logic here too if needed
                        /*if ((index + 1) % 2 === 0) {
                            dot.classList.add('-even');
                        } else {
                            dot.classList.add('-odd');
                        }*/
                    } else {
                        dot.classList.remove('is-active', '-even', '-odd');
                    }
                });
            });



            /*var navDots = info.navItems;
            if (!navDots) return;
            for (var i = 0; i < navDots.length; i++) {
                navDots[i].classList.remove('-even', '-odd');
                ((i + 1) % 2 === 0) ? navDots[i].classList.add('-even') : navDots[i].classList.add('-odd');
            }*/

        }

        function triggerAnimations(info) {
            // 1. Find all animated elements in all slides
            var allAnimateElements = info.container.querySelectorAll('.animate__animated');
            
            // 2. Reset everyone (remove their animation class)
            allAnimateElements.forEach(function(el) {
                var animationClass = el.getAttribute('data-animation');
                el.classList.remove(animationClass);
            });

            // 3. Target ONLY the active slide
            var activeSlide = info.slideItems[info.index];
            var activeAnims = activeSlide.querySelectorAll('.animate__animated');

            // 4. Trigger the animation with a tiny timeout to ensure the browser registers the reset
            activeAnims.forEach(function(el) {
                var animationClass = el.getAttribute('data-animation');
                setTimeout(function() {
                    el.classList.add(animationClass);
                }, 100); 
            });
        }        




        var hgSliderContainer = document.querySelector('.hg-slider-wrap');
        var progressBar = document.querySelector('.progress-fill');

        if (hgSliderContainer && progressBar) {
            // When mouse enters, pause the CSS animation
            hgSliderContainer.addEventListener('mouseenter', function() {
                progressBar.style.animationPlayState = 'paused';
            });

            // When mouse leaves, resume the CSS animation
            hgSliderContainer.addEventListener('mouseleave', function() {
                progressBar.style.animationPlayState = 'running';
            });
        }


        // Inside your tns onInit or right after init:
        /*var dotsWrappers = document.querySelectorAll('.custom-dots-proxy');
        var totalSlides = tnsSliderHighlight.getInfo().slideCount;

        dotsWrappers.forEach(function(wrapper) {
            for (var i = 0; i < totalSlides; i++) {
                var dot = document.createElement('button');
                dot.setAttribute('data-index', i);
                dot.classList.add('proxy-dot');
                
                dot.addEventListener('click', function() {
                    var index = this.getAttribute('data-index');
                    tnsSliderHighlight.goTo(index);
                });
                
                wrapper.appendChild(dot);
            }
        });*/

    });    

    /*Tiny slider services*/
    const tnsSliderEducation = document.querySelectorAll('.-education-tns');
    tnsSliderEducation.forEach(SliderEducation => {
      const tnsSliderEducation = tns({
          rewind: true,
          container: SliderEducation,
          items: 1,
          nav: true,
          controls: false,
          autoplayButtonOutput: false,
          autoplayHoverPause: true,
          autoplay: true,
          autoplayTimeout: 4000,
          gutter: 24,
          loop: false,
          mouseDrag: true,
          controlsPosition: "bottom",
          navPosition: "bottom",
          controlsText: ['<span class="-prev"><iconify-icon icon="lucide:chevron-left"></iconify-icon></span>', '<span class="-next"><iconify-icon icon="lucide:chevron-right"></iconify-icon></span>'],
      });
    });    

    /*Tiny slider testimonials*/
    const tnsSliderTestimonials = document.querySelectorAll('.-testimonials-tns');
    tnsSliderTestimonials.forEach(SliderTestimonials => {
    /*const tnsTestimonials = document.querySelector('.-testimonials-tns');*/
      const tnsSliderTestimonials = tns({
          container: SliderTestimonials,
          items: 3,
          slideBy: 'page',
          autoplay: true,
          controlsContainer: "#custom-testimonials-controls",
          //navContainer: "#custom-testimonials-nav",
          nav: true,
          controls: true,
          autoplayButtonOutput: false,
          autoplayHoverPause: true,
          
          
          autoplayTimeout: 4000,
          gutter: 17,
          loop: false,
          rewind: true,
          mouseDrag: true,
          controlsPosition: "bottom",
          navPosition: "bottom",
          controlsText: ['<span class="-prev"><iconify-icon icon="lucide:arrow-left"></iconify-icon></span>', '<span class="-next"><iconify-icon icon="lucide:arrow-right"></iconify-icon></span>'],
          responsive: { 
              1366: {
                items: 3,
                autoplay: false
                /*items: 2,
                nav: true,
                controls: false,*/
              },
              768: {
                items: 2,
                /*items: 2,
                nav: true,
                controls: false,*/
              },
              320: {
                /*loop: false,
                swipeAngle: false,
                items: 1.4,
                gutter: 24,*/
                items: 1,
                autoplay: true
                //nav: true,
                //gutter: 0
                /*loop: true,
                */
                /*gutter: 0,*/
              }, 
          } 
      });

      var generatedNav = tnsSliderTestimonials.getInfo().navContainer;

      
      var placeholder = document.querySelector('#custom-testimonials-nav');

      
      placeholder.appendChild(generatedNav);
    });


    /*Tiny slider Brands*/
    const tnsSliderBrands = document.querySelectorAll('.-brands-tns');
    tnsSliderBrands.forEach(SliderBrands => {
      const tnsSliderBrands = tns({
          container: SliderBrands,
          items: 4,
          nav: false,
          controls: false,
          autoplayButtonOutput: false,
          autoplayHoverPause: true,
          autoplay: true,
          autoplayTimeout: 3000,
          gutter: 16,
          loop: true,
          mouseDrag: true,
          controlsPosition: "bottom",
          controlsText: ['<span class="-prev"><iconify-icon icon="lucide:arrow-left"></iconify-icon></span>', '<span class="-next"><iconify-icon icon="lucide:arrow-right"></iconify-icon></span>'],
          responsive: { 
              1366: {
               items: 4,
              },
              768: {
                items: 4,
              },
              320: {
                items: 2,
              }, 
          } 
      });
    });

    

    /*Tiny slider sponsor*/
    const tnsSingle = document.querySelector('.-single-tns');
    if (tnsSingle) {
      const tnsSlider = tns({
        container: tnsSingle,
        autoheight: false,
        items: 1,
        /*mouseDrag: true,*/
        autoplayButtonOutput: false,
        autoplay: false,
        loop: true,
        swipeAngle: false,
        navContainer: '.-single-tns-thumbs',
        navAsThumbnails: true,
        controlsText: ['<span class="-prev"><span class="iconify" data-icon="iconoir:arrow-left"></span></span>', '<span class="-next"><span class="iconify" data-icon="iconoir:arrow-right"></span></span>'],
  
        /*responsive: {     
          320: {
          },
          768: {
          },
          900: {
          }
        }*/


      });
      //tnsSlider.updateSliderHeight(); 
      var customizedFunction = function (info, eventName) {
        //tnsSlider.updateSliderHeight();
        //console.log(info);
        var indexCurrent = info.displayIndex;
        console.log(indexCurrent);
        var nextHeight = info.slideItems[indexCurrent].childNodes[1].clientHeight;
        /*console.log(nextHeight)*/
        info.container.offsetParent.childNodes[2].setAttribute('style', 'height:'+ nextHeight + 'px;');
      }
      tnsSlider.events.on('transitionEnd', customizedFunction);
      /*tnsSlider.events.on('indexChanged', customizedFunction);*/
    
    }
    const tnsSingleThumbs = document.querySelector('.-single-tns-thumbs');
    if (tnsSingleThumbs) {
      const tnsSlider = tns({
        container: tnsSingleThumbs,
        items: 6,
        mouseDrag: true,
        nav: false,
        controls: false,
        autoplayButtonOutput: false,
        gutter: 10,
        autoplay: false,
        controlsPosition: "bottom",
        loop: true,
        autoHeight: true,
  
        /*responsive: {     
          320: {
          },
          768: {
          },
          900: {
          }
        }*/

      });   
    
    }


    /*Input Masks*/
    function runmask() {
      v_obj.value=v_fun(v_obj.value);
    }

    function mask(o,f) {
      v_obj=o;
      v_fun=f;
      setTimeout(runmask(),1)
    }

    function mtel(v) {
      v = v.replace(/\D/g, "");
      v = v.replace(/^(\d{2})(\d)/g, "($1) $2");
      v = v.replace(/(\d)(\d{4})$/, "$1-$2");
      return v;
    }

    function modate(v) {
      v = v.replace(/\D/g, "");
      v = v.replace(/^(\d{2})(\d)/g, "$1/$2");
      v = v.replace(/(\d)(\d{3})$/, "$1/$2");
      return v;
    }

    function mnumbers(v) {
      v = v.replace(/\D/g, "");
      return v;
    }
    function mcep(v) {
      v = v.replace(/\D/g, "");
      v = v.replace(/^(\d{5})(\d)/g, "$1-$2");
      return v;
    }
    function price(v) {
        /*v = v.replace(/\D/g, "");
        v = v.replace(/([0-9]{2})$/g, ",$1");
        v = v.replace(/([0-9]{3}),([0-9]{2}$)/g, ".$1,$2");
        v = v.replace(/([0-9]{3}).([0-9]{3}),([0-9]{2}$)/g, ".$1.$2,$3");
        v = v.replace(/([0-9]{3}).([0-9]{3}).([0-9]{3}),([0-9]{2}$)/g, ".$1.$2.$3,$4");
        return v;*/
        v = v + '';
        v = parseInt(v.replace(/[\D]+/g, ''));
        v = v + '';
        v = v.replace(/([0-9]{2})$/g, ",$1");

        if (v.length > 6) {
            v = v.replace(/([0-9]{3}),([0-9]{2}$)/g, ".$1,$2");
        }

        if(v == 'NaN') v = '';
        return v;
    }

    function mCpf(v){
      //Remove tudo o que não é dígito
      v=v.replace(/\D/g,"")

      //Coloca um ponto entre o terceiro e o quarto dígitos
      v=v.replace(/(\d{3})(\d)/,"$1.$2")

      //Coloca um ponto entre o terceiro e o quarto dígitos
      //de novo (para o segundo bloco de números)
      v=v.replace(/(\d{3})(\d)/,"$1.$2")

      //Coloca um hífen entre o terceiro e o quarto dígitos
      v=v.replace(/(\d{3})(\d{1,2})$/,"$1-$2")

      return v  
    }

    function cpfCnpj(v){
        //Remove tudo o que não é dígito
        v = v.replace(/\D/g,"");
     
        if (v.length < 14) { //CPF   405.604.628-08  43.201.151/0001-99
     
            //Coloca um ponto entre o terceiro e o quarto dígitos
            v=v.replace(/(\d{3})(\d)/,"$1.$2")
     
            //Coloca um ponto entre o terceiro e o quarto dígitos
            //de novo (para o segundo bloco de números)
            v=v.replace(/(\d{3})(\d)/,"$1.$2")
     
            //Coloca um hífen entre o terceiro e o quarto dígitos
            v=v.replace(/(\d{3})(\d{1,2})$/,"$1-$2")
     
        } else { //CNPJ
            //console.log('aki');
            //Coloca ponto entre o segundo e o terceiro dígitos
            v=v.replace(/^(\d{2})(\d)/,"$1.$2")
     
            //Coloca ponto entre o quinto e o sexto dígitos
            v=v.replace(/^(\d{2})\.(\d{3})(\d)/,"$1.$2.$3")
     
            //Coloca uma barra entre o oitavo e o nono dígitos
            v=v.replace(/\.(\d{3})(\d)/,".$1/$2")
     
            //Coloca um hífen depois do bloco de quatro dígitos
            v=v.replace(/(\d{4})(\d)/,"$1-$2")
     
        }
     
        return v
     
    }

    var cepValidator = document.getElementsByClassName('mask-cep');
    var cpfValidator = document.getElementsByClassName('mask-cpf');
    var telValidator = document.getElementsByClassName('mask-tel');
    var dateValidator = document.getElementsByClassName('mask-date');
    var priceValidator = document.getElementsByClassName('mask-price');
    var documentValidator = document.getElementsByClassName('mask-doc');
    var numberValidator = document.getElementsByClassName('mask-num');
   

    if(cepValidator && cepValidator.length != -1){
      for (i = 0; i < cepValidator.length; i++) {
        cepValidator[i].addEventListener('keydown', function() {
          mask(this, mcep);
        });
      }
    }
    if(cpfValidator && cpfValidator.length != -1){
      for (i = 0; i < cpfValidator.length; i++) {
        cpfValidator[i].addEventListener('keydown', function() {
          mask(this, mCpf);
        });
      }
    }
    if(telValidator && telValidator.length != -1){
      for (i = 0; i < telValidator.length; i++) {
        telValidator[i].addEventListener('keydown', function() {
          mask(this, mtel);
        });
      }
    }
    if(dateValidator && dateValidator.length != -1){
      for (i = 0; i < dateValidator.length; i++) {
        dateValidator[i].addEventListener('keydown', function() {
          mask(this, modate);
        });
      }
    }
    if(numberValidator && numberValidator.length != -1){
      for (i = 0; i < numberValidator.length; i++) {
        numberValidator[i].addEventListener('keydown', function() {
          mask(this, mnumbers);
        });
      }
    }

    if(priceValidator && priceValidator.length != -1){
      for (i = 0; i < priceValidator.length; i++) {
        priceValidator[i].addEventListener('keyup', function() {
          mask(this, price);
        });
      }
    }

    if(documentValidator && documentValidator.length != -1){
      for (i = 0; i < documentValidator.length; i++) {
        documentValidator[i].addEventListener('keydown', function() {
          mask(this, cpfCnpj);
        });
      }
    }

    /*CEP autocomplete*/
    $(".cep-autocomplete").blur(function(){
        var address = $(this).closest('form').find(".endereco");
        var number = $(this).closest('form').find(".numero");
        var neighborhood = $(this).closest('form').find(".bairro");
        var city = $(this).closest('form').find(".cidade");
        var state = $(this).closest('form').find(".estado");
        var cep = this.value.replace(/[^0-9]/, "");
        if(cep.length != 8){
            return false;
        }        
        var url = "https://viacep.com.br/ws/"+cep+"/json/";
        $.getJSON(url, function(dadosRetorno){ /*console.log(dadosRetorno);*/
            try{
                address.val(dadosRetorno.logradouro);
                neighborhood.val(dadosRetorno.bairro);
                city.val(dadosRetorno.localidade);
                state.val(dadosRetorno.uf);
                number.focus();
            }catch(ex){}
        });
    });                

     /*GDPR*/
    document.addEventListener('DOMContentLoaded', function() {
      var cookiebar = document.querySelector('.cookiebar');
      if (cookiebar) { 
          var closecookiebar = document.querySelector('.hide-cookiebar-target');
          var acceptcookie = document.querySelector('.accept-cookies');
          var refusecookie = document.querySelector('.refuse-cookies');
          var cookie = readCookie('captoleo_cookie_lgpd_consent');/*Name of cookie*/
          //console.log(cookie);

          if (cookie == "true") {
              cookiebar.style.display = "none";
          }else if (cookie == "false") {
              cookiebar.style.display = "none";
          }else{
              cookiebar.classList.add("no-cookie-yet");
          }

          acceptcookie.addEventListener('click', function(e) {
              if(cookie != "true") {
                cookiebar.style.display = "none";
                createCookie('captoleo_cookie_lgpd_consent', "true", 7);
              } 
              e.preventDefault();
          });

          if (refusecookie) {
            refusecookie.addEventListener('click', function(e) {
                if(cookie != "true") {
                  cookiebar.style.display = "none";
                  createCookie('captoleo_cookie_lgpd_consent', "false", 7);
                }
                e.preventDefault();
            });  
          }
          
          if (closecookiebar) {
            closecookiebar.addEventListener('click', function(e) {
                cookiebar.style.display = "none";
                /*if(cookie != "true") {
                  createCookie('captoleo_cookie_lgpd_consent', "true", 1);
                } */
                e.preventDefault();
            });
          }

      }

      function createCookie(name, value, days) {
          if(days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            var expires = "; expires=" + date.toGMTString();
          } else var expires = "";
          document.cookie = name + "=" + value + expires + "; path=/"
      }

      function readCookie(name) {
          var nameEQ = name + "=";
          var ca = document.cookie.split(';');
          for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
           
          }
          return null;
      }

      function eraseCookie(name) {
          createCookie(name, "", -1);
      }

    });

    /*Scroller slider*/
    const iScrollers = document.querySelectorAll(".i-scroll");

    if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      addAnimation();
    }

    function addAnimation() {
      iScrollers.forEach((iScroller) => {
        iScroller.setAttribute("data-animated", true);

        const iScrollerInner = iScroller.querySelector(".i-scroll__inner");
        const iScrollerContent = Array.from(iScrollerInner.children);

        iScrollerContent.forEach((item) => {
          const duplicatedItem = item.cloneNode(true);
          duplicatedItem.setAttribute("aria-hidden", true);
          iScrollerInner.appendChild(duplicatedItem);
        });
      });
    }          

    if(document.querySelector('.hero-video-wrap')){
      (function() {
        const wrap = document.querySelector('.hero-video-wrap');
        const playBtn = document.querySelector('.hero-video-play');
        const youtubeVideo = document.getElementById('heroVideoYoutube');
        const video = document.getElementById('heroVideo');
        let player;
        let isPlayerReady = false; // Flag para evitar o erro

        if (youtubeVideo) {
          // 1. Carrega a API do YouTube
          const tag = document.createElement('script');
          tag.src = "https://www.youtube.com/iframe_api";
          const firstScriptTag = document.getElementsByTagName('script')[0];
          firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

          // 2. Inicializa o Player
          window.onYouTubeIframeAPIReady = function() {
            player = new YT.Player('heroVideoYoutube', {
              videoId: 'R73nl9vDVk0',
              playerVars: {
                'autoplay': 0,
                'mute': 1,
                'controls': 0,
                'rel': 0,
                'showinfo': 0,
                'modestbranding': 1
              },
              events: {
                'onReady': () => { isPlayerReady = true; }, // Ativa a flag quando estiver pronto
                'onStateChange': onPlayerStateChange
              }
            });
          };

          // 3. Clique do Botão (Com proteção contra o erro)
          playBtn.addEventListener('click', () => {
            // Só executa se o player existir E os métodos estiverem disponíveis
            if (player && isPlayerReady && typeof player.getPlayerState === 'function') {
              const state = player.getPlayerState();

              if (state !== YT.PlayerState.PLAYING) {
                player.playVideo();
                player.unMute();
                wrap.classList.add('is-playing');
              } else {
                player.pauseVideo();
                wrap.classList.remove('is-playing');
              }
            } else {
              console.log("O player ainda está carregando...");
            }
          });

          function onPlayerStateChange(event) {
            if (event.data === YT.PlayerState.ENDED) {
              wrap.classList.remove('is-playing');
              player.seekTo(0);
              player.pauseVideo(); 
            }
          }
        }else{
          // Start muted to allow autoplay on some devices after first tap
          video.muted = true;

          playBtn.addEventListener('click', async () => {
            if (video.paused) {
              await video.play();
              wrap.classList.add('is-playing');
              video.muted = false;
            } else {
              video.pause();
              wrap.classList.remove('is-playing');
              video.muted = true;
            }
          });

          // If the video ends and you want it to loop:
          video.addEventListener('ended', () => {
            video.currentTime = 0;
            wrap.classList.remove('is-playing');
            /*video.play();*/
          });
        }
      })();   
    }             

    var header = document.querySelectorAll(".dynamic-header");
    if (!header.length) { return; }
    var headerHeight = header[0].offsetHeight;
    window.onscroll = function() {
      //console.log(window.innerWidth)
        var scrollPosition = document.documentElement.scrollTop || document.body.scrollTop;
        var vh1o3 = (window.innerWidth/3);
        var vh1o2 = (window.innerWidth/2);
        var vhMin = 100;
        var vhMinWA = 200;
        /*if (scrollPosition > headerHeight && window.innerWidth > 992) {*/
        /*if (scrollPosition > headerHeight) {*/
        if (scrollPosition > vhMin) {
                header[0].classList.add('-sticky');
                
        }else{
                header[0].classList.remove('-sticky');
                
        }

        if (scrollPosition > vhMinWA) {
                
                document.body.classList.add("-has-sticky");
        }else{
                
                document.body.classList.remove("-has-sticky");
        }
    }; 

   

}(window.jQuery, window, document));